// extracted by mini-css-extract-plugin
export default {"separator":"separator-lNIW"};